module.exports = __webpack_public_path__ + "static/img/01.a51a6ad2.png";